import React, { Component } from "react";
import { FormHelperText, FormLabel, OutlinedInput } from "@mui/material";

import { withRouter } from "utilities/withRouter";
import validateQuote from "modules/createQuote/validateQuote";
import "./groupNoOfTravellers.css";
import { CONFIGURATION } from "utilities/configuration";
import InputAdornment from "@mui/material/InputAdornment";
import BlockIcon from "@mui/icons-material/Block";
import ClearIcon from "@mui/icons-material/Clear";

class GroupNoOfTravellers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            noOfTravellers: this.props.noOfTravellers ?? ""
        };
    }

    handleClear = () => {
        let { noOfTravellers } = this.state;
        noOfTravellers = "";
        this.setState({ noOfTravellers });
        this.props.handleStep1Data({ target: { name: "noOfTravellers", value: "" } });
        validateQuote.isGroupNumberOfTravellersValid(this.props.quote, this.props.errors, this.props.localize);
    };

    handleChange = (event) => {
        const re = /^[0-9\b]+$/;
        if (event.target.value === "" || re.test(event.target.value)) {
            let { noOfTravellers } = this.state;
            noOfTravellers = event.target.value;
            this.setState({ noOfTravellers });
        }
    };

    handleBlur = (event) => {
        this.props.handleStep1Data(event);
        validateQuote.isGroupNumberOfTravellersValid(this.props.quote, this.props.errors, this.props.localize);
    };

    render() {

        const { error } = this.props;
        const { noOfTravellers } = this.state;

        return (
            <div className="row group-no-of-travellers">
                <div className="row form-control-wrapper">
                    <FormLabel>
                        {this.props.localize("qma-total-number-of-travellers")}
                    </FormLabel>
                    <OutlinedInput
                        fullWidth
                        type="text"
                        name="noOfTravellers"
                        id="outlined-total-number-of-travellers"
                        value={noOfTravellers}
                        inputProps={{ maxLength: 3 }}
                        onBlur={(event) => this.handleBlur(event)}
                        onChange={(event) => this.handleChange(event)}
                        aria-describedby="outlined-total-number-of-travellers"
                        error={error?.trim().length > 0}
                        endAdornment={
                            CONFIGURATION.APPLY_FIELD_ADORNMENT ? <InputAdornment position="end">
                                { noOfTravellers && noOfTravellers.length > 0 ? <ClearIcon className="clear-icon" onClick={this.handleClear} edge="end"/> : null }
                            </InputAdornment> : null
                        }
                    />
                </div>
                <FormHelperText error={error?.trim().length > 0}>
                    {error?.trim().length > 0 && (
                        error
                    )}
                </FormHelperText>
            </div>
        );
    }
}

export default withRouter(GroupNoOfTravellers);